import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-test-id"]
const _hoisted_2 = ["data-test-id"]

import { computed } from 'vue';
import { IPromoCardMini } from '@/interfaces/entities/promo-card-mini.interface';
import { PanelTitleTypes } from '@/enums/panel-title-type.enum';
import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import { MiniCardLayout } from '@/enums/card-layout.enum';
import type { Field, ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';
import PromoCardMini from './PromoCardMini.vue';
import { mapFieldToEnum } from '@/mappers/sc-field-to-enum.mapper';
import { usePageStore } from '@/store';

const defaultMaxSupportedPromoCards = 6;


export default /*@__PURE__*/_defineComponent({
  __name: 'PromoCardMiniList',
  props: {
    bindings: {},
    promoCards: {},
    heading: {},
    cardLayout: {},
    maxItemsToShow: {},
    fields: {},
    rendering: {}
  },
  setup(__props: any) {

const props = __props;

const outerClass = props.rendering?.params?.Styles;
const inlineStyle = props.rendering?.params?.inlineStyle;
const dataTestId = usePageStore().dataTestId(props.rendering);

const resolvedPromoCards = computed(() => {
  if (props.promoCards?.length) {
    return props.promoCards;
  }

  const fieldItems = props.fields?.items;

  if (Array.isArray(fieldItems)) {
    return fieldItems.map((item) => item.fields as Partial<IPromoCardMini>).filter((fields) => !!fields);
  }

  return [];
});

const resolvedHeading = computed(() => {
  return props.heading ?? (props.fields?.heading as Field<string>);
});

const resolvedCardLayoutField = computed(() => {
  return props.cardLayout ?? (props.fields?.cardLayout as Field<string>);
});

const resolvedCardLayout = computed<MiniCardLayout | undefined>(() =>
  mapFieldToEnum(MiniCardLayout, resolvedCardLayoutField.value)
);

const resolvedMaxItemsToShow = computed(() => {
  return (
    props.maxItemsToShow?.value ??
    (props.fields?.maxItemsToShow as Field<number>)?.value ??
    defaultMaxSupportedPromoCards
  );
});

const displayedPromoCards = computed(() => resolvedPromoCards.value.slice(0, resolvedMaxItemsToShow.value));

const contentGridClasses = computed(() => {
  if (resolvedCardLayout.value === MiniCardLayout.HORIZONTAL) {
    return 'grid grid-cols-1 md:grid-cols-2 gap-y-4 md:gap-x-6';
  } else if (resolvedCardLayout.value === MiniCardLayout.VERTICAL_STACKED) {
    return 'grid grid-cols-1 md:grid-cols-3 gap-y-4 md:gap-x-6';
  } else if (resolvedCardLayout.value === MiniCardLayout.HORIZONTAL_WITH_BUTTON) {
    return 'flex flex-col gap-y-4';
  }

  return '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-test-id": _unref(dataTestId),
    class: _normalizeClass(_unref(outerClass)),
    style: _normalizeStyle(_unref(inlineStyle))
  }, [
    (resolvedHeading.value?.value)
      ? (_openBlock(), _createBlock(PanelTitle, {
          key: 0,
          title: resolvedHeading.value,
          subTitle: { value: undefined },
          panelType: { value: _unref(PanelTitleTypes).Subheading },
          bindings: { outerClass: 'mb-2' }
        }, null, 8, ["title", "panelType"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(contentGridClasses.value)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedPromoCards.value, (promoCard, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          "data-test-id": promoCard.dataTestId?.value || _unref(dataTestId) + '_' + index
        }, [
          _createVNode(PromoCardMini, _mergeProps({ ref_for: true }, promoCard, { cardLayout: resolvedCardLayout.value }), null, 16, ["cardLayout"])
        ], 8, _hoisted_2))
      }), 128))
    ], 2)
  ], 14, _hoisted_1))
}
}

})